module.exports = __webpack_public_path__ + "static/media/skeleton_archer_head.3004d83d.png";